
function Accomplishments() {
    return (
      <section id="accomplishments"> 
      <div class= "relative container mx-auto" >
      
      <h1 class="text-4xl font-bold text-center md:text-5xl md:text-left md:ml-20 lg:ml-32 xlg:ml-72">
            Accomplishments
          </h1>
          </div>
      </section>
    );
  }

export default Accomplishments;